import { ComponentType, useState } from 'react';

import { FirstTabContent } from './FirstTabContent';

export type HelpTabsType = {
	title: string;
	tabKey: number;
	content: HelpTabsContentType;
};
export type HelpTabsContentType = {
	title: string;
	overtitle: string;
	CustomContent: ComponentType | undefined;
	imageSrc: string;
	text: string;
};

export const HELP_TABS: readonly HelpTabsType[] = [
	{
		title: 'help_modal.tabs.tab_1.name',
		tabKey: 1,
		content: {
			title: 'help_modal.tabs.tab_1.title',
			overtitle: 'help_modal.tabs.tab_1.name',
			CustomContent: FirstTabContent,
			imageSrc: '/context/admin/mip-create-help/mip_create_help_tab_1.png',
			text: '',
		},
	},
	{
		title: 'help_modal.tabs.tab_2.name',
		tabKey: 2,
		content: {
			title: 'help_modal.tabs.tab_2.title',
			overtitle: 'help_modal.tabs.tab_2.name',
			text: 'help_modal.tabs.tab_2.text',
			imageSrc: '/context/admin/mip-create-help/mip_create_help_tab_2.png',
			CustomContent: undefined,
		},
	},
	{
		title: 'help_modal.tabs.tab_3.name',
		tabKey: 3,
		content: {
			title: 'help_modal.tabs.tab_3.title',
			overtitle: 'help_modal.tabs.tab_3.name',
			text: 'help_modal.tabs.tab_3.text',
			imageSrc: '/context/admin/mip-create-help/mip_create_help_tab_3.png',
			CustomContent: undefined,
		},
	},
	{
		title: 'help_modal.tabs.tab_4.name',
		tabKey: 4,
		content: {
			title: 'help_modal.tabs.tab_4.title',
			overtitle: 'help_modal.tabs.tab_4.name',
			text: 'help_modal.tabs.tab_4.text',
			imageSrc: '/context/admin/mip-create-help/mip_create_help_tab_4.png',
			CustomContent: undefined,
		},
	},
	{
		title: 'help_modal.tabs.tab_5.name',
		tabKey: 5,
		content: {
			title: 'help_modal.tabs.tab_5.title',
			overtitle: 'help_modal.tabs.tab_5.name',
			text: 'help_modal.tabs.tab_5.text',
			imageSrc: '/context/admin/mip-create-help/mip_create_help_tab_5.png',
			CustomContent: undefined,
		},
	},
	{
		title: 'help_modal.tabs.tab_6.name',
		tabKey: 6,
		content: {
			title: 'help_modal.tabs.tab_6.title',
			overtitle: 'help_modal.tabs.tab_6.name',
			text: '',
			imageSrc: '/context/admin/mip-create-help/mip_create_help_tab_6.png',
			CustomContent: undefined,
		},
	},
];

export const useMipCreateHelpModalController = () => {
	const [activeTab, setActiveTab] = useState(HELP_TABS[0]!);

	const onNextArrowClick = () => {
		const nextTabKey = activeTab.tabKey + 1;
		const nextTab = HELP_TABS.find((tab) => tab.tabKey === nextTabKey);
		if (!nextTab) {
			return;
		}

		setActiveTab(nextTab);
	};

	const onPrevArrowClick = () => {
		const prevTabKey = activeTab.tabKey - 1;
		const prevTab = HELP_TABS.find((tab) => tab.tabKey === prevTabKey);
		if (!prevTab) {
			return;
		}

		setActiveTab(prevTab);
	};

	return { activeTab, setActiveTab, onPrevArrowClick, onNextArrowClick };
};
